<template>
    <div>
        <hr>
        <b-row>
            <b-col>
                <h5>Школы</h5>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="1" style="background-color: #241ABB">

            </b-col>
            <b-col>
                Есть свободные места
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: #3FA3F1">

            </b-col>
            <b-col>
                Требуется увеличить число мест до 1.5 раз
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: #0CF4DA">

            </b-col>
            <b-col>
                Требуется увеличить число мест более чем в 1.5 раза
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col>
                <h5>Жилые дома</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: gray">
            </b-col>
            <b-col>
                Нет жителей школьного возраста
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: #1E9E0B">
            </b-col>
            <b-col>
                Есть места в ближайшей школе
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: #49D16D">
            </b-col>
            <b-col>
                Есть места в ближайшей школе, но численность учеников в ней больше проектной
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="1" style="background-color: #dff61a">
            </b-col>
            <b-col>
                Есть места в шаговой доступности
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: orange">
            </b-col>
            <b-col>
                Нет мест в шаговой доступности
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1" style="background-color: red">
            </b-col>
            <b-col>
                Нет школ поблизости
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "MapLegend"
    }
</script>

<style scoped>

</style>